import { useEffect, useEffectEvent } from 'react'

import { onStreamEvent, onStreamReconnect } from './event-registry'

/**
 * Subscribes for the lifetime of the component. `useEffectEvent` keeps the
 * handler current without re-subscribing every time its identity changes — a
 * resubscribe per render would drop events in the gap.
 */
export function useStreamEvent(type: string, handler: (payload: unknown) => void) {
  const onEvent = useEffectEvent(handler)

  useEffect(() => onStreamEvent(type, onEvent), [type])
}

/** Refetch this screen's snapshot after a gap in the stream. */
export function useStreamReconnect(handler: () => void) {
  const onReconnect = useEffectEvent(handler)

  useEffect(() => onStreamReconnect(onReconnect), [])
}
